import type { StaticImport } from "next/dist/shared/lib/get-img-props";
import Image from "next/image";
import type { ComponentPropsWithRef } from "react";

import { cn } from "@/services/styles/cn";

export function IconItem({
  icon,
  title,
  children,
  className,
  ...props
}: ComponentPropsWithRef<"li"> & {
  icon: StaticImport;
  title: string;
}) {
  return (
    <li className={cn("flex flex-col max-lg:items-center max-lg:text-center", className)} {...props}>
      <Image src={icon} alt={title} width={60} height={60} />
      <strong className="mt-6 text-lg">{title}</strong>
      <p className="mt-3">{children}</p>
    </li>
  );
}
